import { atom } from "recoil";

import { ParametrosSas } from "@app/api/configuracoes";
import { Usuario } from "./api/usuario";

export const parametrosSasState = atom({
  key: 'parametrosSasState',
  default: {} as ParametrosSas,
});

export const usuarioLogadoState = atom({
  key: 'usuarioLogadoState',
  default: {} as Usuario,
});
